import { useState, useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { previewAssessment } from '../../containers/upf-assign/upf-assign-actions';
import Resources from '../resources';
import { getTeacherAuthToken } from '../utils';
import { getLocale } from '../locale';

export default function usePreview(questions, handleError = () => { }) {
  const selectedCourse = useSelector(state => state.UPFAssignReducer.selectedCourse);
  const selectedAssessmentType = useSelector(state => state.UPFAssignReducer.selectedAssessmentType);
  const selectedProduct = useSelector(state => state.product, shallowEqual);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  const handlePreview = async (duration, durationType, randomize) => {
    setIsLoading(true);
    const previewData = await dispatch(previewAssessment({
      questions,
      productId: selectedProduct && selectedProduct.id,
      courseId: selectedCourse && selectedCourse.id,
      courseVersion: selectedCourse && selectedCourse.version,
      assessmentTypeId: selectedAssessmentType.id,
      duration,
      durationType,
      randomize
    }));

    if (previewData) {
      const assessmentUrl = await Resources.env.getConfigurationItem('AssessmentMLEBaseUrl');
      const token = getTeacherAuthToken();
      const locale = getLocale();
      // eslint-disable-next-line max-len
      const url = `${assessmentUrl}?authToken=${token}&assignmentId=${previewData.assignmentId}&locale=${locale}&isPreview=true&newContent=true`;
      window.open(url, '_blank');
    } else {
      handleError();
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const nextIsLoading = selectedCourse === -1 || !questions.length;
    if (nextIsLoading !== isLoading) {
      setIsLoading(nextIsLoading);
    }
  }, [selectedCourse, questions]);

  return [
    isLoading,
    handlePreview
  ];
}
